import {Modal} from "@shopify/polaris";
import React from "react";
import intl from "../../../../i18n/intl";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import utils from '../../../../utils/utils'
const UpgradePlanModal = ({num,importOpen,setImportOpen}) => {
    const router  = useHistory()
  return (
    <>
      <Modal
        open={importOpen}
        onClose={() => setImportOpen()}
        title={intl.get("Reach the list product limit")}
        primaryAction={{
          content: intl.get("Upgrade Plan"),
          onAction: () => {
            setImportOpen()
            utils.routeListen('/admin/subscribe')
            utils.routeJump1(router,'/admin/subscribe')
          },
        }}
        secondaryActions={[
          {
            content: intl.get("Cancel"),
            onAction: () => setImportOpen(),
          },
        ]}
      >
        <Modal.Section>
         <p style={{margin:"24px",fontSize:'16px'}}>
         {intl.get("You have reached the daily import limit of {{num}} Dropshipman products, you can upgrade your plan to get more products to import.",num)} 
          </p>
        </Modal.Section>
      </Modal>
    </>
  );
};

export default UpgradePlanModal;
